import { Column, Text } from "@/components";

export const EnrichmentPortalHeader = ({
  firstName,
  lastName,
}: {
  firstName: string | null;
  lastName: string | null;
}) => {
  /* Helpers */
  const initials =
    `${firstName?.charAt(0) ?? ""}${lastName?.charAt(0) ?? ""}`.toUpperCase() ||
    "?";

  /* Render */
  const render = () => {
    return (
      <Column className="items-center pb-3 pt-8">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-900 shadow-sm">
          <Text className="text-2xl font-semibold text-white">{initials}</Text>
        </div>
        <Text className="mt-6 text-2xl" variant="header">
          Enrich <span className="text-primary-700">{firstName}&apos;s</span>{" "}
          profile
        </Text>
        <Text className="mt-2" variant="muted">
          Candidate information used as input for enrichment
        </Text>
      </Column>
    );
  };

  return render();
};
